export const mouseButtonEnum = {
  main: 'main',
  sub: 'sub',
  aux: 'aux',
};

export default {
  isOverElement(mouseEvent, { element = undefined, elementBoundingClientRect = undefined }) {
    if (elementBoundingClientRect === undefined) {
      if (element === undefined) {
        return undefined;
      } else {
        elementBoundingClientRect = element.getBoundingClientRect();
      }
    }
    if (mouseEvent.clientY < elementBoundingClientRect.y) return false;
    if (mouseEvent.clientY >= (elementBoundingClientRect.y + elementBoundingClientRect.height)) return false;
    if (mouseEvent.clientX < elementBoundingClientRect.x) return false;
    if (mouseEvent.clientX >= (elementBoundingClientRect.x + elementBoundingClientRect.width)) return false;
    return true;
  },

  getMouseButton(mouseEvent) {
    switch (mouseEvent.button) {
    case 0:
      return mouseButtonEnum.main;
    case 1:
      return mouseButtonEnum.aux;
    case 2:
      return mouseButtonEnum.sub;
    default:
      return undefined;
    }
  },

  isNoMouseButtonPressed(mouseEvent) {
    return (mouseEvent.buttons === 0);
  },

  isAnyMouseButtonPressed(mouseEvent) {
    return (mouseEvent.buttons > 0);
  },

  isMainMouseButtonPressed(mouseEvent) {
    return ((mouseEvent.buttons & 1) !== 0);
  },

  isSubMouseButtonPressed(mouseEvent) {
    return ((mouseEvent.buttons & 2) !== 0);
  },

  isAuxMouseButtonPressed(mouseEvent) {
    return ((mouseEvent.buttons & 4) !== 0);
  },
}